<form [formGroup]="recoverPasswordForm">

    <div class="row no-gutters">

        <div class="col-md-12 col-lg-6">

            <div class="row no-gutters">
                <div class="col-sm-10">
                    <mat-form-field class="full-width mt-3">
                        <mat-label>{{ 'login.recover_password.label.password1' | translate }}</mat-label>
                        <input *ngIf="!showPassword"
                               id="{{idPrefix}}input_password.password1"
                               type="password" matInput
                               formControlName="password1"
                               (ngModelChange)="validatePassword()"
                               tabindex="1"
                               required>
                        <input *ngIf="showPassword"
                               id="{{idPrefix}}input_text.password1"
                               type="text" matInput
                               formControlName="password1"
                               (ngModelChange)="validatePassword()"
                               tabindex="1"
                               required>
                        <button id="{{idPrefix}}btn.show_password"
                                type="button"
                                mat-button
                                matSuffix mat-icon-button
                                tabindex="-1"
                                (click)="toggleShowPassword()">
                            <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="recoverPasswordForm.hasError('required', ['password1'])">{{ 'login.recover_password.error.required' | translate }}</mat-error>
                        <mat-error *ngIf="recoverPasswordForm.hasError('pattern', ['password1'])">{{ 'login.recover_password.error.pattern.invalid' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col-sm-10">
                    <mat-form-field class="full-width">
                        <mat-label>{{ 'login.recover_password.label.password2' | translate }}</mat-label>
                        <input *ngIf="!showPassword"
                               id="{{idPrefix}}input_password.password2"
                               type="password" matInput
                               formControlName="password2"
                               [errorStateMatcher]="errorStateMatcher"
                               (ngModelChange)="validatePassword()"
                               tabindex="2"
                               required>
                        <input *ngIf="showPassword"
                               id="{{idPrefix}}input_text.password2"
                               type="text" matInput
                               formControlName="password2"
                               [errorStateMatcher]="errorStateMatcher"
                               (ngModelChange)="validatePassword()"
                               tabindex="2"
                               required>
                        <mat-error *ngIf="recoverPasswordForm.hasError('notEqual')">{{ 'login.recover_password.error.not_equal' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </div>

        </div>

        <div class="col-md-12 col-lg-6">
            <span class="smp-title-thin-border">{{ 'login.recover_password.title.password_requirements' | translate }}</span><br/>

            <ul class="mt-2 extra-margin-left">
                <li class="requirement" [ngClass]="{'validated': hasUpper }">{{ 'login.recover_password.error.pattern.uppercase' | translate }}</li>
                <li class="requirement" [ngClass]="{'validated': hasLower }">{{ 'login.recover_password.error.pattern.lowercase' | translate }}</li>
                <li class="requirement" [ngClass]="{'validated': hasNumber }">{{ 'login.recover_password.error.pattern.number' | translate }}</li>
                <li class="requirement" [ngClass]="{'validated': hasSpecial }">{{ 'login.recover_password.error.pattern.special_char' | translate }}</li>
                <li class="requirement" [ngClass]="{'validated': has8 }">{{ 'login.recover_password.error.pattern.min_length_8' | translate }}</li>
            </ul>
        </div>

    </div>

</form>
